/* eslint-disable no-param-reassign, default-case */
import { createSelector } from 'reselect';
import produce from 'immer';
import get from 'lodash.get';
import { ADD_DRAFT, RECEIVE_SHOW_DRAFTS } from './shared-constants';
import { addOneToImmerState, addManyToImmerState } from './util';

export const selectDrafts = state => get(state, ['v2', 'drafts', 'items'], null);
export const selectDraft = draftId =>
  createSelector(
    selectDrafts,
    drafts => drafts && drafts[draftId]
  );

const initialState = {
  total: null,
  items: {},
};

export default produce((state, action) => {
  switch (action.type) {
    case RECEIVE_SHOW_DRAFTS:
      addManyToImmerState(state, action.payload);
      return;
    case ADD_DRAFT:
      addOneToImmerState(state, action.payload);
  }
}, initialState);
